import { Card, CardHeader, CardBody, CardFooter, Button, Divider } from "@heroui/react";
import "./PillsSidebar.css";
import {Attachment} from "../../state/project";

type Props = {
    palette?: string[];
    pillole?: string[];
    onAddColor?: () => void;
    onRegenerate?: () => void;

    technicalKeywords: string[];
    currentPhaseIndex: number;
    setCurrentPhaseIndex?: (index: number) => void;

    attachments?: Attachment[];

};

export const PillsSidebar = ({
                                 palette = [],
                                 pillole = [],
                                 onAddColor,
                                 onRegenerate,

                                    technicalKeywords,
                                    currentPhaseIndex,
                                    setCurrentPhaseIndex,

                                 attachments = [],


                             }: Props) => {

    return (
        <aside className="pillsSidebar">
            {/* Panel: Pillole in fase 1 */}

            {pillole.length > 0 && currentPhaseIndex == 1 && (
                <Card className="pillsCard" shadow="sm">
                    <CardHeader className="pillsHeader">
                        <h4 className="pillsTitle">Lo sapevi che...</h4>
                    </CardHeader>

                    <Divider />

                    <CardBody className="pillsBody">

                        {pillole.length > 0 && (
                            <section className="panelBlock">
                                {/*<div className="panelTitle">Lo sapevi che…</div>*/}
                                <div className="pillCards">
                                    {pillole.slice(0, 2).map((p, i) => (
                                        <div className="pillCardHero" key={i}>{p}</div>
                                    ))}
                                </div>
                            </section>
                        )}
                    </CardBody>
                </Card>

            )}
            {/* Panel: Brief tecnico e moodboard */}
            {currentPhaseIndex > 1 && (
                <Card className="pillsCard" shadow="sm">
                <CardHeader className="pillsHeader">
                    <h4 className="pillsTitle">Brief tecnico e moodboard</h4>
                </CardHeader>

                <Divider />

                <CardBody className="pillsBody">


                    <section className="wipPanel">
                        <div className="wipPanelHeader">Parole chiave</div>

                        <div className="kwGrid">
                            {technicalKeywords.length > 0 ? (
                                technicalKeywords.map((kw, i) => (
                                    <span className="kwChip" key={`${kw}-${i}`}>
                    <span className="kwSpark" aria-hidden="true">✦</span>
                    <span className="kwText">{kw}</span>
                                        {/*<span className="kwX" aria-hidden="true">×</span>*/}
                  </span>
                                ))
                            ) : (
                                <div className="kwEmpty">Le parole chiave appariranno qui.</div>
                            )}

                            {/*<button type="button" className="kwAdd" onClick={() => {}}>
                                <span className="plusCircle" aria-hidden="true">+</span>
                                <span>Aggiungi</span>
                            </button>*/}
                        </div>
                    </section>


                        <section className="panelBlock">
                            <div className="panelTitle">Palette colore</div>

                            <div className="paletteWrap">
                                {palette.map((hex, i) => (
                                    <span className="paletteChip" key={i}>
                      <span className="swatch" style={{ background: hex }} />
                                        {hex.toUpperCase()}
                    </span>
                                ))}
                            </div>

                            {/*<Button className="wFullBtn" onPress={onAddColor}>
                                Aggiungi
                            </Button>*/}
                        </section>

                    {currentPhaseIndex == 2 && (
                        <Button
                            className="wipCta"
                            onPress={() => {
                                // Aggiorna currentPhaseIndex a 3
                                setCurrentPhaseIndex && setCurrentPhaseIndex(3);
                            }}
                        >
                            Genera design visuale bicchiere
                        </Button>
                    )}

                    </CardBody>


                    {/*<CardFooter className="pillsFooter">
                        <Button className="wFullBtn primaryCta" onPress={onRegenerate}>
                            Rigenera Moodboard
                        </Button>
                    </CardFooter>*/}

                    {/* Create a button vai alla Fase 2 that update currentPhaseIndex a 2 */}

                </Card>
            )}

            {currentPhaseIndex >= 3 && (

                <Card className="pillsCard" shadow="sm">
                    <CardHeader className="pillsHeader">
                        <h4 className="pillsTitle">Design visuale bicchiere</h4>
                    </CardHeader>

                    <Divider />

                    <CardBody className="pillsBody">

                <section className="panelBlock">
                    <div className="panelTitle">Immagini selezionate</div>

                    {attachments.length > 0 ? (
                        <div className="galleryGrid">
                            {attachments.map((attachment, i) => (
                                <button
                                    type="button"
                                    className="galleryItem"
                                    key={`${attachment.url}-${i}`}
                                    onClick={() => window.open(attachment.url, "_blank")}
                                    title="Apri immagine"
                                >
                                    <img src={attachment.url} alt={`Selezione ${i + 1}`} loading="lazy" />
                                </button>
                            ))}
                        </div>
                    ) : (
                        <div className="galleryEmpty">
                            Metti “pollice su” alle immagini in chat e compariranno qui.
                        </div>
                    )}
                </section>
                    </CardBody>
                </Card>

            )}

        </aside>
    );
};
